import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=263d1cf2&scoped=true&lang=html"
import script from "./Default.vue?vue&type=script&lang=ts"
export * from "./Default.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263d1cf2",
  null
  
)

export default component.exports